//
// README - Alpha Component
//
// This component has not yet been implemented in a production environment and will
// likely go through some additional iterations before landing at a final solution.
//
// Please reach out to the Cadence team if you intend to use this!
//

import React from 'react';
import classNames from 'classnames';

import { TimesCircleAltIcon } from '../../icons/react';

interface RCChipProps {
  /** RCChips are simpler than RCButtons and expect only a toggled state, if anything */
  selected?: boolean;
  /** This may or may not be the right handler, as this is an alpha component. It does need to track its own state but the interface may change when we implement it */
  onChange?: (selected: boolean) => void;
  /** We allow any markup here for overall consistency but this should likely remain a simple string */
  children: React.ReactNode;
  /** These sizes are set up to replicate our RCButton sizes; contact Cadence if you need other size variants */
  size?: 'small' | 'mini';
}

export function RCChip({
  selected: controlledState = false,
  onChange: setControlledState = undefined,
  size = 'small',
  children,
}: RCChipProps) {
  const [uncontrolledState, setUncontrolledState] = React.useState(controlledState);
  const isControlled = controlledState !== undefined && setControlledState !== undefined;
  const isSelected = isControlled ? controlledState : uncontrolledState;

  function handleClick(selected: boolean) {
    if (!isControlled) {
      setUncontrolledState(selected);
    }
    setControlledState?.(selected);
  }

  const classes = classNames(
    'rc-chip',
    {
      'rc-chip--small': size === 'small',
      'rc-chip--mini': size === 'mini',
    }
  );

  return (
    <button
      className={classes}
      type="button"
      aria-pressed={isSelected}
      onClick={() => handleClick(!isSelected)}
    >
      {children}
      {isSelected &&
        <div className="rc-chip__remove">
          <TimesCircleAltIcon />
        </div>
      }
    </button>
  );
}
